export class ProductForm extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (this.form) {
      this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this), { capture: true })
    }
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError('needs to be wrapped around a product\'s <form> element')
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()
    e.stopImmediatePropagation()

    const variantId = this.querySelector('input[name="id"]').value
    const productIdInput = this.querySelector('input[name="product-id"]')
    if (productIdInput) {
      localStorage.setItem(`lastGWPVariant${productIdInput.value}`, variantId)
    }

    await this.addToCart()
  }

  async addToCart () {
    const result = await window.BAO.Cart.addItemFromForm(this.form)
    return result
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

if (!customElements.get('bao-product-form')) {
  customElements.define('bao-product-form', ProductForm)
}
